
let resolveRefreshToken = null
let refreshToken = new Promise((res) => resolveRefreshToken = res)

export const setRefreshToken = (newRefreshToken, sessionKey) => {
  refreshToken = newRefreshToken
  resolveRefreshToken(refreshToken)
  if (sessionKey) {
    window.localStorage.setItem(sessionKey, newRefreshToken)
  }
}
// export const getRefreshToken = () => refreshToken
export const getRefreshToken = () => window.localStorage.getItem("refreshToken")